import { Button, Space } from 'antd';
import VoteContent from './vote';
import NoticeContent from './notice';
import { useState } from 'react';
const tabMap = {
  vote: {
    name: '投票活动',
    value: 'vote',
  },
  notice: {
    name: '活动公告',
    value: 'notice',
  },
};

const VoteActivityPage: React.FC = () => {
  const [active, setActive] = useState(tabMap.vote.value);

  const onTabChange = (value: 'vote' | 'notice') => {
    console.log(value, 'value');
    if (value === active) return;
    setActive(value);
  };

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        {Object.values(tabMap).map((tab) => {
          // return <div key={tab.value}>{tab.name}</div>;
          const value = tab.value as 'vote' | 'notice';
          const type = active === tab.value ? 'primary' : 'default';
          return (
            <Button
              key={tab.value}
              type={type}
              onClick={() => onTabChange(value)}
            >
              {tab.name}
            </Button>
          );
        })}
      </Space>
      <div style={{ display: active === tabMap.vote.value ? 'block' : 'none' }}>
        <VoteContent />
      </div>
      <div
        style={{ display: active === tabMap.notice.value ? 'block' : 'none' }}
      >
        <NoticeContent />
      </div>
    </>
  );
};

export default VoteActivityPage;
